<template>
    <div>
        <div v-if="readonly || disabled">{{inputValue}}</div>
        <div class="ivu-select ivu-select-single ivu-select-default option-box" ref="dropRef" v-else>
            <div v-if="multiple" :style="`width: ${width||'210px'};`" @mouseover="(values.length|| constValues.length || content)? isDeleteButton=true : isDeleteButton=false" @mouseleave="isDeleteButton=false">
                <div style="height:auto;min-height:32px !important;padding:0 0 0 5px;" class="ivu-select-selection" @click="selectUp" ref="multipleR">
                    <Tag v-if="values.length==1" closable @on-close="handleClose()">{{values[0].name}}</Tag>
                    <Tag v-if="values.length>1">已选{{values.length}}项</Tag>
                    <Tag v-if="constValues.length==1" closable @on-close="handleClose()">{{constValues[0].name}}</Tag>
                    <Tag v-if="constValues.length>1">已选{{constValues.length}}项</Tag>
                    <input v-if="!options || options.length == 0" class="ivu-select-input" :style="inputStyle" ref="inputVal" style="padding: 0 0 0 4px;" v-model="inputValue" type="text" autocomplete="off" @keyup="selectKeyDown" onautocomplete="off" @compositionstart="flag=false" @compositionend="flag=true" :placeholder="values.length?'':placeholder">
                    <input v-if="options && options.length > 0 " class="ivu-select-input" :style="inputStyle" @keyup="shopInput" ref="inputVal" style="padding: 0 0 0 4px;" v-model="constinputValue" type="text" autocomplete="off" onautocomplete="off" @compositionstart="flag=false" @compositionend="flag=true" :placeholder="constValues.length?'':placeholder">
                </div>
                <span class="delete-selected" style="top:10px" @click="selectUp">
                    <Icon :type="contentShow?'ios-arrow-up':'ios-arrow-down'" size="14" color="#808695" style="margin-left: 4px;" />
                </span>
                <span class="delete-selected" v-if="clear && isDeleteButton" @click="deleteButtonClick()">
                    <Icon type="ios-close-circle" size="14" color="#5C6B77" style="margin-left: 4px;" />
                </span>
            </div>
            <div v-else class="ivu-select-selection " :style="`width: ${width||'200px'};`" @mouseover="(inputValue|| content)? isDeleteButton=true : isDeleteButton=false" @mouseleave="isDeleteButton=false">
                <input class="ivu-select-input" id="tentant-input" v-model="inputValue" type="text" autocomplete="off" @click="selectUp" @keyup="selectKeyDown" onautocomplete="off" @compositionstart="flag=false" @compositionend="flag=true" :placeholder="placeholder">
                <span class="delete-selected" @click="selectUp">
                    <Icon :type="contentShow?'ios-arrow-up':'ios-arrow-down'" size="14" color="#808695" style="margin-left: 4px;" />
                </span>
                <span class="delete-selected" v-if="clear && isDeleteButton" @click="deleteButtonClick()">
                    <Icon type="ios-close-circle" size="14" color="#5C6B77" style="margin-left: 4px;" />
                </span>
            </div>
            <div>
                <div v-if="!options || options.length == 0">
                    <div class="ivu-select-dropdown selected-content" :style="{top:(multiple?paddTop+'px':'30px')}" v-if="contentShow" id="selected-content" v-loadmore="{loadMore:loadMoreGroup}">
                        <ul class="el-scrollbar__view ivu-select-dropdown-list ul-content">
                            <li class="ivu-select-item option-item" :class="{ selected: multiple?values.some(row=>(row._id||row.code) == (i._id||i.code)):index === current}" v-for="(i, index) in contentOptions" :key="index" @click="contentClick(i, index)">
                                <div>
                                    <p class="nowrap" :style="`max-width: ${selectionWidth}px;`">{{i.name}}</p>
                                    <p style="color:#ccc;" class="nowrap">{{i.code}}</p>
                                </div>
                                <div v-show="multiple && values.some(row=>(row._id||row.code) == (i._id||i.code))">
                                    <Icon type="ios-checkmark" size='24' color="rgba(32, 191, 100, 0.9)" />
                                </div>
                            </li>
                            <li class=" hint jcsb">
                                <span>共 <span style="color: #888;">{{totalTenants}}</span> 条结果</span>
                            </li>
                        </ul>
                        <p class="tip-class" v-if="contentOptions.length === 0 && !loading">暂无数据</p>
                        <p class="tip-class" v-if="loading">数据加载中...</p>
                    </div>
                </div>
                <div v-else>
                    <div class="ivu-select-dropdown selected-content" :style="{top:(multiple?paddTop+'px':'30px')}" v-if="contentShow" id="selected-content">
                        <ul class="el-scrollbar__view ivu-select-dropdown-list ul-content">
                            <li class="ivu-select-item option-item" :class="{ selected: multiple?constValues.some(row=>row.name == i.name):index === current}" v-for="(i, index) in fixationOptions" :key="index" @click="constClick(i, index)">
                                <div>
                                    <p class="nowrap" style="max-width: 200px;">{{i.name}}</p>
                                </div>
                                <div v-show="multiple && constValues.some(row=>row.name == i.name)">
                                    <Icon type="ios-checkmark" size='24' color="rgba(32, 191, 100, 0.9)" />
                                </div>
                            </li>
                            <li class=" hint jcsb">
                                <span>共 <span style="color: #888;">{{fixationOptions.length}}</span> 条结果</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import CommonService from '@/logics/services/common'
    const commonService = new CommonService()
    export default {
        props: {
            //参数
            parameter: {
                type: Object,
                default: () => { }
            },
            placeholder: {
                type: String,
                default: '请选择'
            },
            value: { //需要回显的数据
                type: [Object, Array],
            },
            type: {
                type: String,
                default: 'organization' //organization机构、supplier供应商、warehouse仓库、category类别
            },
            readonly: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            autoload: {
                type: Boolean,
                default: false
            },
            //是否多选
            multiple: {
                type: Boolean,
                default: false
            },
            //没有请求的options
            options: {
                type: Array,
                default: () => []
            },
            //是否展示清空
            clear: {
                type: Boolean,
                default: true
            },
            width: {
                type: String,
            },
            transfer: {
                type: Boolean
            },
            fields: {
                type: Object,
            },
            sort: Object,
        },
        watch: {
            parameter: {
                deep: true,
                immediate: true, //深度监听设置为 true
                handler(val) {
                    this.optionsObj = val
                    if (val && this.autoload) {
                        this.optionsObj = val
                        this.inputValue = val.keywords
                        this.page = 1
                        this.currentValue = this.value
                        this.selectScroll(this.value)
                    }
                }
            },
            options: {
                deep: true,
                handler(val) {
                    this.fixationOptions = val
                }
            },
            value: {
                deep: true,
                handler(val) {
                    if (!val) {
                        this.content = val
                        this.inputValue = ''
                        this.currentValue = null
                        return
                    }
                    if (val.name !== undefined) {
                        this.content = val
                        let label = this.content ? this.content.name : ''
                        // this.optionsObj.keywords = label
                        this.inputValue = label
                    } else {
                        // this.optionsObj.keywords = ''
                        this.inputValue = ''
                        this.content = null
                    }
                    if (!this.multiple) {
                        this.page = 1
                    }
                    this.currentValue = val
                    // this.selectScroll()
                }
            },
        },
        computed: {
            inputStyle() {
                let style = {};
                if (this.multiple) {
                    if ((this.values && this.values.length == 0) || (this.options && this.options.length && this.constValues && this.constValues.length == 0)) {
                        style.width = this.width || '100%';
                    } else {
                        style.width = this.width || ((this.inputValue ? this.inputValue.length : 0) * 12 + 20 + 'px') || ((this.constinputValue ? this.constinputValue.length : 0) * 12 + 20) + 'px';
                        this.$nextTick(() => {
                            this.paddTop = this.$refs.multipleR.offsetHeight
                        })
                    }
                }
                return style;
            },
            selectionWidth() {
                let maxlength = Math.max(...this.options.map(item => { return (item.name ? item.name : item).length }))
                return maxlength * 12 + 20
            }
        },
        directives: {
            loadmore: {
                bind(el, binding) {
                    el.addEventListener('scroll', function () {
                        const isBottom = this.scrollHeight - this.scrollTop <= this.clientHeight + 1
                        //this.scrollHeight>281 搜索后不调用
                        if (isBottom && this.scrollHeight > 281) {
                            binding.value.loadMore()
                        }
                    })
                }
            }
        },
        data() {
            return {
                currentValue: null,
                optionsObj: {},
                flag: true,
                contentOptions: [], //options数据
                loading: false, //是否加载中
                isAllLoaded: false, //是否还有更多数据
                isDeleteButton: false, //是否显示删除
                content: null, //选中的机构对象
                inputValue: '', //输入框的值
                current: '', //下拉框悬浮，高亮
                totalTenants: 0, //总数量
                contentShow: false, //下拉框是否显示
                timeout: null,
                inited: false,
                count: 0,
                page: 1,
                session: this.$store.session,
                values: [],
                constValues: [],
                paddTop: 30,
                fixationOptions: [],
                constinputValue: '',
                multiChanged: false,
            }
        },
        mounted() {
            if (this.options.length) this.fixationOptions = this.options
            this.optionsObj = this.parameter
            document.addEventListener('click', this.outClick)
            if (this.multiple) {
                console.log('this.value', this.value)
                this.values = this.value || []
            } else {
                if (!this.value) {
                    this.content = this.value
                    this.inputValue = ''
                    return
                }
                if (this.value.name !== undefined) {
                    this.content = this.value
                    this.currentValue = this.value
                    let label = this.content ? this.content.name : ''
                    this.inputValue = label
                } else {
                    this.inputValue = ''
                    this.content = null
                }
            }
        },
        destroyed() {
            document.removeEventListener('click', this.outClick)
        },
        methods: {
            shopInput() {
                let copyZhanghao = this.copy(this.options)
                let list = copyZhanghao.filter(row => {
                    return row.name.indexOf(this.constinputValue) > -1
                })
                this.fixationOptions = list
            },
            constClick(row, index) {
                this.current = index;
                if (this.constValues.some(item => item.name == row.name)) {
                    let i = this.constValues.findIndex(item => item.name == row.name);
                    this.constValues.splice(i, 1)
                } else {
                    this.constValues.push(row)
                }
                this.$nextTick(() => {
                    this.paddTop = this.$refs.multipleR.offsetHeight
                })
                this.dataChanged(this.constValues)
            },
            async loadMoreGroup() {
                if (this.totalTenants == this.contentOptions.length) return
                this.page++
                this.optionsObj.page = this.page
                this.optionsObj.size = 10
                let list;
                if (this.type == "organization" || this.type == "jigou") {
                    list = await commonService.getOrganiztion(this.optionsObj)
                } else if (this.type == "supplier" || this.type == "gonghuojigou") {
                    list = await commonService.getSublevel(this.optionsObj)
                } else if (this.type == 'warehouse' || this.type == "cangku") {
                    list = await commonService.getwarehouse(this.optionsObj)
                } else if (this.type == 'category' || this.type == "leibie") {
                    list = await commonService.getCategory(this.optionsObj)
                } else if (this.type == 'bumen') {
                    list = await commonService.getBumen(this.optionsObj)
                } else if (this.type == 'biaoqian') {
                    list = await commonService.getBiaoqian(this.optionsObj)
                } else if (this.type == 'yuanyin') {
                    list = await commonService.getYuanyin(this.optionsObj)
                } else if (this.type == 'wupin') {
                    list = await commonService.getWupin(this.optionsObj)
                } else if (this.type == 'caipin') {
                    list = await commonService.getCaipin(this.optionsObj)
                } else if (this.type == 'waixiaokehu') {
                    list = await commonService.getWaixiaokehu(this.optionsObj)
                } else {
                    list = await commonService.getItems(this.optionsObj, this.type)
                }
                if (list.success) {
                    // this.totalTenants = list.total
                    this.loading = false
                    if (this.type == "organization" || this.type == "jigou") {
                        this.contentOptions = this.contentOptions.concat(list.jigous)
                    } else if (this.type == "supplier" || this.type == "gonghuojigou") {
                        this.contentOptions = this.contentOptions.concat(list.gonghuojigous)
                    } else if (this.type == 'warehouse' || this.type == "cangku") {
                        this.contentOptions = this.contentOptions.concat(list.cangkus)
                    } else if (this.type == 'category' || this.type == "leibie") {
                        this.contentOptions = this.contentOptions.concat(list.leibies)
                    } else if (this.type == 'bumen') {
                        this.contentOptions = this.contentOptions.concat(list.bumens)
                    } else if (this.type == 'biaoqian') {
                        this.contentOptions = this.contentOptions.concat(list.biaoqians)
                    } else if (this.type == 'yuanyin') {
                        this.contentOptions = this.contentOptions.concat(list.yuanyins)
                    } else if (this.type == 'wupin') {
                        this.contentOptions = this.contentOptions.concat(list.wupins)
                    } else if (this.type == 'caipin') {
                        this.contentOptions = this.contentOptions.concat(list.caipins)
                    } else if (this.type == 'waixiaokehu') {
                        this.contentOptions = this.contentOptions.concat(list.waixiaokehus)
                    } else {
                        this.contentOptions = this.contentOptions.concat(list.items)
                    }
                    if (this.content) this.current = this.contentOptions.findIndex(o => { return o._id == this.content._id })
                }
            },
            dataChanged(value) {
                if (this.multiple) {
                    this.currentValue = value
                    this.multiChanged = false
                    this.$emit('change', value)
                } else {
                    if (value === null || (JSON.stringify(this.currentValue) != JSON.stringify(value))) {
                        this.currentValue = value
                        this.$emit('change', value)
                    }
                }
            },
            handleClose() {
                if (this.options.length == 0) {
                    this.values.splice(0, 1)
                    if (this.values.length == 0) {
                        this.paddTop = 30
                        this.content = null
                        this.inputValue = ''
                    }
                    this.dataChanged(this.values)
                } else {
                    this.constValues.splice(0, 1)
                    this.dataChanged(this.constValues)
                }
                if (this.constValues.length == 0) {
                    this.paddTop = 30
                }
            },
            outClick(e) {
                let dropRef = this.$refs.dropRef
                if (dropRef && !dropRef.contains(e.target) && this.contentShow) {
                    if (this.multiple) {
                        if (this.options.length > 0) {
                            if (this.multiChanged) this.dataChanged(this.constValues)
                        } else {
                            if (this.multiChanged) this.dataChanged(this.values)
                        }
                    } else if (!this.inputValue || !this.content || (this.content && this.inputValue != this.content.name)) {
                        this.content = null
                        this.inputValue = ''
                        this.dataChanged(this.content)
                    }
                    this.contentShow = false
                }
            },
            // 清除input值事件
            deleteButtonClick() {
                if (this.multiple) {
                    this.values = []
                    this.constValues = []
                    this.paddTop = 30
                    this.constinputValue = ''
                }
                this.content = null
                this.inputValue = ''
                this.current = '';
                this.page = 1
                this.selectScroll()
                this.dataChanged(this.content)
            },
            selectUp() {
                this.count++
                this.contentShow = !this.contentShow
                if (this.$refs.inputVal) this.$refs.inputVal.focus()
                if (!this.autoload && this.count == 1) {
                    this.selectScroll(this.content)
                }
            },
            // select框键盘弹起事件（键盘弹起时，触发搜索事件）
            selectKeyDown() {
                // 向后台查询时，将原来select框的值置空
                if (this.flag) {
                    this.contentOptions = [];
                    // // 重新获取数据
                    // this.selectScroll();
                    // 搜索时弹出下拉列表
                    this.page = 1
                    this.contentShow = true
                    if (this.timeout) {
                        clearTimeout(this.timeout)
                    }
                    this.timeout = setTimeout(this.selectScroll, 500);
                }
            },
            // 请求options数据 //需根据后端返回判断是否加载完毕
            async selectScroll() {
                if (!this.optionsObj || this.readonly) return //没有传入搜索参数时暂不加载（避免页面初始化时，多次加载）
                this.loading = true
                let label = this.inputValue
                if (this.optionsObj.keywords === undefined) {
                    this.optionsObj.keywords = ''
                } else {
                    this.optionsObj.keywords = label
                }
                this.optionsObj.size = 10
                this.optionsObj.page = this.page
                this.optionsObj.fields = this.fields
                this.optionsObj.sort = this.sort
                if (this.parameter.queryfn) {
                    this.optionsObj.query = this.parameter.queryfn()
                    console.log('this.optionsObj.query', this.optionsObj.query)
                }
                let list;
                if (this.type == "organization" || this.type == "jigou") {
                    list = await commonService.getOrganiztion(this.optionsObj)
                } else if (this.type == "supplier" || this.type == "gonghuojigou") {
                    list = await commonService.getSublevel(this.optionsObj)
                } else if (this.type == 'warehouse' || this.type == "cangku") {
                    list = await commonService.getwarehouse(this.optionsObj)
                } else if (this.type == 'category' || this.type == "leibie") {
                    list = await commonService.getCategory(this.optionsObj)
                } else if (this.type == 'bumen') {
                    list = await commonService.getBumen(this.optionsObj)
                } else if (this.type == 'biaoqian') {
                    list = await commonService.getBiaoqian(this.optionsObj)
                } else if (this.type == 'yuanyin') {
                    list = await commonService.getYuanyin(this.optionsObj)
                } else if (this.type == 'wupin') {
                    list = await commonService.getWupin(this.optionsObj)
                } else if (this.type == 'caipin') {
                    list = await commonService.getCaipin(this.optionsObj)
                } else if (this.type == 'waixiaokehu') {
                    list = await commonService.getWaixiaokehu(this.optionsObj)
                } else {
                    list = await commonService.getItems(this.optionsObj, this.type)
                }
                if (list.success) {
                    this.totalTenants = list.total
                    this.loading = false
                    if (this.type == "organization" || this.type == "jigou") {
                        this.contentOptions = list.jigous
                    } else if (this.type == "supplier" || this.type == "gonghuojigou") {
                        this.contentOptions = list.gonghuojigous
                    } else if (this.type == 'warehouse' || this.type == "cangku") {
                        this.contentOptions = list.cangkus
                    } else if (this.type == 'category' || this.type == "leibie") {
                        this.contentOptions = list.leibies
                    } else if (this.type == 'bumen') {
                        this.contentOptions = list.bumens
                    } else if (this.type == 'biaoqian') {
                        this.contentOptions = list.biaoqians
                    } else if (this.type == 'yuanyin') {
                        this.contentOptions = list.yuanyins
                    } else if (this.type == 'wupin') {
                        this.contentOptions = list.wupins
                    } else if (this.type == 'caipin') {
                        this.contentOptions = list.caipins
                    } else if (this.type == 'waixiaokehu') {
                        this.contentOptions = list.waixiaokehus
                    } else {
                        this.contentOptions = list.items
                    }
                    let current = this.currentValue
                    let newvalue
                    if (current) {
                        newvalue = this.contentOptions.findOne({ _id: current._id })
                    }
                    if (current && newvalue) {
                        this.currentValue = newvalue
                        this.content = newvalue
                        this.label = newvalue.name
                        this.inputValue = this.label
                        this.current = this.contentOptions.findIndex(o => { return o._id == current._id })
                    } else if (this.contentOptions.length == list.total) {
                        this.currentValue = null
                        this.content = null
                        this.label = ''
                        this.inputValue = this.label
                        this.current = -1
                    }
                }
            },
            // 下拉框内容点击事件
            contentClick(row, index) {
                if (this.multiple) {
                    this.current = index;
                    if (this.values.some(item => (item._id || item.code) == (row._id || row.code))) {
                        let i = this.values.findIndex(item => (item._id || item.code) == (row._id || row.code));
                        this.values.splice(i, 1)
                    } else {
                        this.values.push(row)
                    }
                    this.$nextTick(() => {
                        this.paddTop = this.$refs.multipleR.offsetHeight
                    })
                    // this.dataChanged(this.values)
                    this.currentValue = this.values
                    this.$emit('localSearchchange', this.values)
                    this.multiChanged = true
                } else {
                    this.current = index;
                    this.content = row;
                    this.inputValue = this.content ? this.content.name : ''
                    this.contentShow = false
                    this.dataChanged(row)
                }
            },
        }
    }
</script>
<style lang="less" scoped>
    .option-box {
        position: relative;
    }

    .delete-selected {
        position: absolute;
        right: 8px;
        top: 8px;
        color: "#5C6B77";
        cursor: pointer;
    }

    .selected {
        font-weight: bold;
        color: #01baad;
    }

    .el-select .el-input {
        width: 130px;
    }

    .selected-content {
        transform-origin: center top;
        position: absolute;
        top: 30px;
        left: 2px;
        min-width: 200px;
        max-height: 281px;
        background: #ffffff;
        border-radius: 4px;
        border: solid 1px #e4e7ed;
        overflow: auto;
        z-index: 999;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    }

    .tip-class {
        text-align: center;
        height: 30px;
        line-height: 30px;
        color: #b8b4b4;
        font-size: 15px;
        background-color: #f4f4f4;
    }

    .hint {
        margin-top: 4px;
        border-top: 1px solid #f4f4f4;
        font-size: 13px;
        padding: 7px 16px;
        color: #ccc;
    }

    .option-item {
        display: flex;
        justify-content: space-between;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/BaseSelect/index.vue?5885fb42